import { render, staticRenderFns } from "./FeatureCardDataRow.vue?vue&type=template&id=60252ac9&scoped=true&"
import script from "./FeatureCardDataRow.vue?vue&type=script&lang=js&"
export * from "./FeatureCardDataRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60252ac9",
  null
  
)

export default component.exports